export class NotificationMessage{
    successMessage:string;
    errorMessage:string;
    warningMessage:string;
}


// WEBPACK FOOTER //
// ./src/app/modules/common/entity/notification-message.ts